import * as React from 'react';

import { createStore, useStore } from 'zustand';

import { GetReviewsQuery } from '@notino/shared/definitions/types';

export type Review = NonNullable<
  NonNullable<GetReviewsQuery['reviewsAndFilters']>['data']
>['reviews'][number];
export type Image = NonNullable<Review['images']>[number];

export const createReviewPhotoModalStore = ({
  reviewId,
  initialImage,
}: {
  reviewId: number;
  initialImage: Image;
}) =>
  createStore<{
    reviewId: number;
    selectedImage: Image;
    actions: {
      setImage: (image: Image) => void;
    };
  }>((set) => ({
    reviewId,
    selectedImage: initialImage,
    actions: {
      setImage: (image) => set({ selectedImage: image }),
    },
  }));

const Context = React.createContext<
  ReturnType<typeof createReviewPhotoModalStore>
>(null!);

export const ReviewPhotoModalProvider = Context.Provider;

export const useReviewPhotoModalStore = <T>(
  selector: Parameters<
    typeof useStore<ReturnType<typeof createReviewPhotoModalStore>, T>
  >[1]
) => {
  const ctx = React.useContext(Context);
  if (!ctx) {
    throw new Error(
      'useReviewPhotoModalStore must be used inside ReviewPhotoModalProvider'
    );
  }
  return useStore(ctx, selector);
};
